import React, { Component } from "react";
import "./Layout.scss";
import MarbesAuthApi from "mc/lib/api/gen/reactcore/MarbesAuthApi";
import { Redirect } from "react-router-dom";
import { detail, Loader, storeFromArea, authActions, modal } from "@mc/mc-legacy";
import { connect } from "react-redux";
import { Route, Switch } from "react-router";
import { documentRoot } from "../routes";
import { getPozadavkyMenuItems, getUkolyMenuItems } from "../const/MenuItems";
import EmptyPage from "./EmptyPage";
import VysledkyVyhledaniPage from "./VysledkyVyhledaniPage";
import SestavyPage from "./SestavyPage";
import { toastr } from "../utils/mc-toastr";
import { ModalManager } from "@mc/react-core";
import MobilFooter from "../components/MobilFooter";
import OkamzitePodepsaniPage from "./OkamzitePodepsaniPage";
import ZalozitPozadavekPage from "./ZalozitPozadavekPage";
import SchvalovaniMobilFooter from "../components/SchvalovaniMobilFooter";
const { AUTH_INFO_AREA, ID } = authActions;
const CHECK_TIME = 1000 * 60 * 5; // 5 minut

class Layout extends Component {
  static propTypes = {
    // children: PropTypes.any.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      logout: false,
    };
  }

  componentDidMount() {
    this.fetchData(this.props);
    this.check();
  }

  check = () => {
    MarbesAuthApi.check().then((data) => {
      if (this.props.isFetched) {
        if (!this.props.isGuest && !data.auth) {
          toastr.info("Automatické odhlášení");
          this.props.dispatch(detail.DetailActions.setData(AUTH_INFO_AREA, ID, {}));
        } else {
          setTimeout(this.check, CHECK_TIME);
        }
      } else {
        setTimeout(this.check, CHECK_TIME);
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    props.dispatch(authActions.fetchAuthInfoIfNeeded());
  };

  render() {
    const { isGuest, isFetched, isSigner, isAdmin } = this.props;
    const documentRoots = documentRoot(isAdmin).documentRootRoutes;

    if (!isFetched) {
      return <Loader />;
    }

    if (isGuest || this.state.logout) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: {
              from: this.props.location,
            },
          }}
        />
      );
    }

    if (this.props.location.pathname === "/") {
      let item;

      if (isSigner) {
        item = getUkolyMenuItems()[0];
      } else {
        item = getPozadavkyMenuItems()[0];
      }

      return (
        <Redirect
          to={{
            pathname: item.path,
            state: {
              from: this.props.location,
            },
          }}
        />
      );
    }

    return (
      <div className="layout-container">
        <modal.ModalDialog key="modal-dialog" />
        <ModalManager />
        <Switch key="switch">
          {documentRoots}
          <Route key={"zalozitPozadavek"} path={"/pre/detail/:uuid"} component={ZalozitPozadavekPage} />
          <Route key={"okamzitePodepsani"} path={"/detail/:uuid"} component={OkamzitePodepsaniPage} />
          <Route path="/vyhledavani" component={VysledkyVyhledaniPage} />
          <Route path="/sestavy" component={SestavyPage} />
          <Route path="/" component={EmptyPage} />
        </Switch>
        <Route path={"/ukoly/nevyrizene"} component={MobilFooter} />
        <Route path={"/ukoly/historie"} component={MobilFooter} />
        <Route path={"/ukoly/schvaleniNevyrizene"} component={SchvalovaniMobilFooter} />
        <Route path={"/ukoly/schvaleniHistorie"} component={SchvalovaniMobilFooter} />
        <Route path={"/vyhledavani"} component={MobilFooter} />
      </div>
    );
  }
}

export default connect((state, props) => {
  const authInfo = storeFromArea(state, authActions.AUTH_INFO_AREA);
  return {
    isFetched: authInfo.fetched,
    isGuest: !authInfo.fetched || !authInfo.data.auth,
    isSigner: !authInfo.fetched || authInfo.data.signer,
    isAdmin: !authInfo.fetched || authInfo.data.admin,
  };
})(Layout);
